module.exports = __webpack_public_path__ + "img/info.9ff3fd5d.svg";